import { useRef } from "react";
import { Link } from "react-router-dom";
import UploadingIndicator from "../UploadingIndicator/UploadingIndicator";
import FilePreview from "../FilePreview/FilePreview";

const FileUploadField = ({
  label,
  accept,
  onUpload,
  files,
  onRemove,
  loading,
  multiple = false,
  fileType,
  isError = false,
  fileClassName = "form-group",
}) => {
  const fileInputRef = useRef(null);

  const fileUploadHandler = (e) => {
    onUpload(e.target.files);
    e.target.value = null;
  };

  return (
    <div className={fileClassName}>
      <div
        className={`field-container d-flex align-items-center px-3 body-bg rounded-10 mb-3 border ${
          isError ? "border-danger" : "border-gray-300"
        }`}
        onClick={() => fileInputRef.current.click()}
        style={{ cursor: "pointer" }}
      >
        <label className="text-nowrap me-3">{label}</label>
        <p className="form-control text-gray-600 border-0 rounded-0 shadow-none">
          {accept}
        </p>
        <Link to="#" className="upload-file">
          <span className="d-block material-symbols-outlined icon-lg">
            upload
          </span>
        </Link>
        <input
          type="file"
          className="d-none"
          onChange={fileUploadHandler}
          accept={multiple ? "*" : accept}
          ref={fileInputRef}
          multiple={multiple}
        />
      </div>

      {loading ? (
        <UploadingIndicator />
      ) : (
        files.length > 0 && (
          <FilePreview files={files} onRemove={onRemove} fileType={fileType} />
        )
      )}
    </div>
  );
};

export default FileUploadField;
